var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "to",
    style: {
      backgroundColor: _vm.background
    }
  }, [_c('div', {
    staticClass: "addresses"
  }, _vm._l(_vm.addresses, function (addr, i) {
    return _c('div', {
      key: i,
      staticClass: "addr_container"
    }, [_vm.$vuetify.breakpoint.smAndDown ? _c('span', {
      staticClass: "label"
    }, [_vm._v("To")]) : _vm._e(), _c('AddressLink', {
      attrs: {
        "address": addr.displayAddress
      }
    })], 1);
  }), 0), _c('div', {
    staticClass: "amount"
  }, [!_vm.isNFT ? _c('div', {
    staticClass: "value monospace"
  }, [_vm._v(" " + _vm._s(_vm.amount)), _c('span', {
    staticClass: "leftover"
  }, [_vm._v(_vm._s(_vm.leftover))])]) : _vm._e(), _c('div', {
    staticClass: "symbol"
  }, [_c('router-link', {
    attrs: {
      "to": "/asset/".concat(_vm.asset.id)
    }
  }, [_vm._v(_vm._s(_vm.asset.symbol))])], 1)])]);
}
var staticRenderFns = []

export { render, staticRenderFns }